import { render, staticRenderFns } from "./ageGate.vue?vue&type=template&id=332fa05c&"
import script from "./ageGate.vue?vue&type=script&lang=js&"
export * from "./ageGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports